import React from 'react';
import PropTypes from 'prop-types';
import LocalizedLink from 'helpers/LocalizeLink';

function SocialTradingWidget(props) {
    return (
        props.items.map((item, index) => {
            return (
                <div key={index}>
                    <div key={'st_' + index} className={'' + (item.title.length > 0 ? '' : '')}>
                        <h2>{item.title}</h2>
                        <p>{item.descriptions}</p>
                        {
                            item.button_text ?
                                <LocalizedLink to={item.path?item.path:null}>
                                    <button type="button">{item.button_text}</button>
                                </LocalizedLink> : null
                        }
                    </div>
                </div>
            )
        })
    )
}

SocialTradingWidget.propTypes = {
    title: PropTypes.string,
    descriptions: PropTypes.string,
    additional_text: PropTypes.string,
    button_text: PropTypes.string,
    path: PropTypes.string,
    img: PropTypes.string,
    position: PropTypes.number,
    widget: PropTypes.string,
    className: PropTypes.string,
    items: PropTypes.array,
}

export default SocialTradingWidget;
